export default __webpack_public_path__ + "static/media/fish&chips-Regular.48570744.woff";